import { Navbar } from "@/components/Navbar";
import { CartDrawer } from "@/components/CartDrawer";
import { Footer } from "@/components/Footer";
import { Hero } from "@/sections/Hero";
import { About } from "@/sections/About";
import { LifestyleCta } from "@/sections/LifestyleCta";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Navbar />
      <CartDrawer />
      <Hero />
      <About />
      <LifestyleCta />
      <Footer />
    </main>
  );
}
